import RecipesApi from '../../apis/Recipes';

export default {
    namespaced: true,
    state: {
        recipes: []
    },
    mutations: {
        set_recipes (state, data) {
            state.recipes = data;
        }
    },
    actions: {
        async getAllRecipes ({commit}, filters) {
            return await RecipesApi.get_all(filters)
                        .then( response => {
                            commit('set_recipes', response.data)
                        })
                        .catch( error => {
                            console.log(error);
                        })
        },
        async store({commit}, recipe) {
            return await RecipesApi.store(recipe)
                            .then( response => {
                                console.log(response);
                            })
                            .catch( error => {
                                console.log(error);
                            })
        },
    }
}